import { render } from "./AgencyTemplate.vue?vue&type=template&id=a1adc972&scoped=true"
import script from "./AgencyTemplate.vue?vue&type=script&lang=js"
export * from "./AgencyTemplate.vue?vue&type=script&lang=js"

import "./AgencyTemplate.vue?vue&type=style&index=0&id=a1adc972&scoped=true&lang=css"

import exportComponent from "/var/www/html/webmobtuts/realestateapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1adc972"]])

export default __exports__